<template>
  <div style="background-color: #f6f6f6; min-height: 100vh">
    <div style="background-color: #fff">
      <div class="bg">
        <div class="title">
          {{ details.title }}
        </div>
      </div>
    </div>
    <div class="mid">
      <div v-if="details.phone" @click="callPhone(details.oriPhone)">
        <i
          style="
            font-style: normal;
            font-size: 13px;
            font-weight: 400;
            color: #666666;
          "
          >联系电话</i
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ details.phone }}
      </div>
      <!-- <div @click="Click" class="yuyue">预约看房</div>
      <img
        class="yuyue"
        style="width: 5px; right: 6%"
        src="https://dximg.dexian.ren/right.png"
        alt=""
      /> -->
    </div>

    <div class="mid" style="margin-bottom: 1px">
      <div>内容</div>
      <div style="font-weight: 400" v-html="details.content"> </div>
    </div>

    <!-- <div class="bottom">
      <van-button class="submit" @click="Click">预约看房</van-button>
    </div> -->
  </div>
</template>

<script>
import { getLessee, } from '@/api/Changan-zhsq/evaluating'
import "swiper";
import Vue from "vue";
import { Toast } from "vant";
import { Dialog } from "vant";
Vue.use(Toast);
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      minDate: new Date(),
      maxDate: new Date(2038, 12, 30),
      datafrom: {
        LeaseId: "", // 房源ID
        ShowTime: new Date(), // 看房时间
      },
      details: {},
      list: [],
      goodsid: "", //商品id
      addressShow: false, //弹出框
      addressList: [], //地址
      checked: "", //选中内容
      usreData: [], //会员信息
      shopNum: "", //商品数量
      orderid: "", //订单id
      shoppingList: [], //购物车商品列表
      memberDetail: {},
    };
  },
  created() {
    this.wxGetPromotion(); //商品详情
  },
  methods: {
    maskPhoneNumberWithRegex(phoneNumber) {
      if(!phoneNumber){
        return
      }
  if (typeof phoneNumber !== 'string' || !/^\d{11}$/.test(phoneNumber)) {
    // throw new Error('Invalid phone number');
    return phoneNumber
  }
  return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
},
callPhone(phone) {
      window.location.href = "tel:" + phone;
    },
    // 获取房源详情
    wxGetPromotion() {
      let params={
        id:this.$route.params.Id,
        openId: this.$route.query.openid
      }
      getLessee(params).then((res) => {
        console.log(res);
        res.data.data.oriPhone = res.data.data.phone
        res.data.data.phone = this.maskPhoneNumberWithRegex(res.data.data.phone)
        this.details = res.data.data;

        console.log(this.details, "this.details");
        // this.getshoppingList(this.orderid);
      });
    },
  },
};
</script>

<style scoped>
body {
  background-color: #f6f6f6;
}
.bg {
  width: 90%;
  margin: 15px auto 0;
}
.homebanner {
  width: 100%;
  /* margin-top: 15px; */
}

.homebanner img {
  width: 100%;
}

.title {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #0c0c0c;
}

.money {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fc4839;
  margin-top: 10px;
}

.des {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 5%;
  height: 74px;
  border-top: 1px solid #f4f4f4;
  text-align: center;
}

.max {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #0c0c0c;
}

.min {
  font-size: 11px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #999999;
}

.mid {
  position: relative;
  box-sizing: border-box;
  /* height: 97px; */
  padding: 2% 5%;
  background-color: #fff;
  margin-bottom: 12px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #0c0c0c;
  line-height: 22px;
}

.mid div:nth-child(1) {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #0c0c0c;
  margin: 7px 0;
}
.mid div:nth-child(2),
.mid div:nth-child(3) {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #0c0c0c;
  line-height: 22px;
}

.mid .yuyue {
  font-size: 13px !important;
  font-family: PingFang SC;
  font-weight: 500 !important;
  color: #4b6c8d !important;
  position: absolute;
  top: 50%;
  right: 10%;
  transform: translateY(-50%);
}

.add {
  width: 88%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.submit {
  width: 90%;
  height: 43.5px;
  background: #fc4839;
  border-radius: 8px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
}

.bottom {
  text-align: center;
  height: 70px;
  line-height: 60px;
  background: #ffffff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.08);
}
</style>
